import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import { getKPIsClientPlants } from "modules/reporting/fordReports/kpis/store/kpis.actions";
import { makeActualScoreCardFilterData } from "modules/reporting/fordReports/utils";
import LoadingComponent from "modules/primitives/loading/loading.component";
import genericStyles from '../../styles.module.scss';
import styles from './styles.module.scss';

const FordClientPlants = ({ clientPlants, filters }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!clientPlants.data) {
      const makeFilters = makeActualScoreCardFilterData(filters);
      const payload = {
        enqueueSnackbar,
        data: makeFilters,
      };

      dispatch(getKPIsClientPlants(payload))
    }
  }, []);

  return (
    <div className={classNames(genericStyles.columnCard, 'px-0 pb-0 mb-0')}>
      {
        clientPlants.fetching ? (
          <LoadingComponent customText="Getting data..." />
        ) : (
          <div className="d-flex flex-column">
            <span className={classNames(genericStyles.columnCardTitle, 'ml-2')}>Projects/Plant</span>
            <div className={styles.numbersTableWrapper}>
              <div className="d-flex py-2 border-bottom">
                <div className="col-7 small">Plant</div>
                <div className="col-5 text-right small">No. Projects</div>
              </div>
              <div className={styles.tableBody}>
                {
                  clientPlants.data.map(plant => (
                    <div className={styles.tableRow} key={plant.id}>
                      <div
                        className={classNames('d-flex align-items-center col-7 pl-1 pr-2 py-1 small', styles.tableRowWithBorderRight)}>{plant.name}</div>
                      <div className="col-5 px-3 text-right py-2">{plant.value}</div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default React.memo(FordClientPlants);
